import { OptionKV } from "~styled/selector/Selector";

export const TRIMESTRAL = 3;
export const CUATRIMESTRAL = 4;
export const SEMESTRAL = 6;
export const ANUAL = 12;

const vigenciasSolicitudEmisionOptions: Record<string, string> = {
  [TRIMESTRAL]: "Trimestral",
  [CUATRIMESTRAL]: "Cuatrimestral",
  [SEMESTRAL]: "Semestral",
  [ANUAL]: "Anual",
};

const vigenciasSolicitudEmision: number[] = [
  TRIMESTRAL,
  CUATRIMESTRAL,
  SEMESTRAL,
  ANUAL,
];

const vigenciasSolicitudEmisionFilter: OptionKV<number>[] = [
  {
    label: vigenciasSolicitudEmisionOptions[TRIMESTRAL],
    value: TRIMESTRAL,
  },
  {
    label: vigenciasSolicitudEmisionOptions[CUATRIMESTRAL],
    value: CUATRIMESTRAL,
  },
  {
    label: vigenciasSolicitudEmisionOptions[SEMESTRAL],
    value: SEMESTRAL,
  },
  {
    label: vigenciasSolicitudEmisionOptions[ANUAL],
    value: ANUAL,
  },
];

export {
  vigenciasSolicitudEmisionOptions,
  vigenciasSolicitudEmision,
  vigenciasSolicitudEmisionFilter,
};
